import React, { useState, useEffect } from "react";
import CustomSvg from "../../svgs/CustomSvg";
import "../css/chat.css";
import ChatMsgs from "./ChatMsgs";
import userProfile1 from "../../../assets/images/userProfile1.png";
import { FaComments } from "react-icons/fa";
import { getRequest } from "./../../apiRequests/requestApi";
// Utility to format notifications for display
function formatNotifications(notifications, logo, formatDateString) {
  return notifications.map((notif) => {
    const isUserMsg = notif.senderInformation && notif.senderInformation.avatar;
    return {
      image: notif.image || logo,
      text: notif.body,
      title: notif.title,
      date: formatDateString ? formatDateString(notif.createdAt, "long") : notif.createdAt,
      senderProfile: isUserMsg ? notif.senderInformation.avatar : notif.image || logo,
      senderName: isUserMsg ? notif.senderInformation.username : "Skyboard",
      type: isUserMsg ? "user" : "system",
      read: notif.read,
    };
  });
}

export default function ChatRoom({ activeChat, accountType, notifications = [] }) {
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [formattedNotifications, setNotifications] = useState([]);

  // Filter notifications for unread chat messages using formattedNotifications
  const unreadMessages = formattedNotifications.filter(
    (n) => n.title === "New Message" && !n.read
  );

  // Format unread messages for display (already formatted)
  const formattedUnreadMessages = unreadMessages;

  const toggleOptions = () => setIsOptionsOpen(!isOptionsOpen);

  // Fetch notifications from the server
  const fetchNotifications = async () => {
    try {
      const response = await getRequest("/notifications");
      if (!response.data) {
        setNotifications([]);
        return;
      }
      // Use formatNotifications to process the response
      const formatted = formatNotifications(
        response.data,
        userProfile1,
        undefined // Replace with your formatDateString if available
      );
      setNotifications(formatted);
    } catch (error) {
      setNotifications([]);
    }
  };

  // Effect to fetch notifications when the component mounts
  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <div className="h-100 w-100">
      {activeChat ? (
        <div className="m-0 p-0 w-100 h-100 chat-room-container">
          {/* Chat Header */}
          <div
            className={` flex align-items-center justify-content-between p-3 ${
              accountType === "celebrity" ? "bg-green-600" : " bg-pink-300"
            }`}
          >
            <div className="d-flex align-items-center">
              <div
                className={`  rounded-circle d-flex flex-column align-items-center justify-content-center p-1 position-relative`}
              >
                <img
                  src={activeChat.avatar || userProfile1}
                  style={{ width: "50px", height: "50px", objectFit: "cover" }}
                  className={` border rounded-full ${
              accountType === "celebrity" ? "border-green-600" : " border-pink-300"
            }`}
                  alt={activeChat.name || "User"}
                />
                <div className="chat-chat-room-active-chat-container-online-status"></div>
              </div>

              <div className="ms-3">
                <p className="m-0 p-0 text-sm font-weight-600 text-white font-family-poppins capitalize">
                  {activeChat.username}
                </p>
                <p className="m-0 p-0 text-sx text-white font-family-poppins">
                  {activeChat.isOnline ? "Online" : "Last seen recently"}
                </p>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <button
                className="bg-transparent border-0 p-2 me-2"
                onClick={toggleOptions}
              >
                <CustomSvg name="dots-vertical" color="#FFF" />
              </button>
            </div>
          </div>

          {/* Chat Messages Area - Using a dedicated container for proper layout */}
          <div className="chat-messages-area">
            <ChatMsgs accountType={accountType} activeChat={activeChat} />
          </div>
        </div>
      ) : (
        <div className="chat-empty-state">
          <div className="chat-empty-state-icon">
            <FaComments />
          </div>
          <h3 className="txt-BD3193 font-weight-600 mb-3">Your Messages</h3>
          {unreadMessages.length > 0 ? (
  <div className="mb-4">
    <div className="text-[#BD3193] font-semibold mb-2">Unopened Messages</div>
    <ul className="list-unstyled">
      {formattedUnreadMessages.map((msg, idx) => (
        <li key={msg.id || idx} className="d-flex align-items-center mb-3" style={{gap: 12}}>
          <img
            src={msg.senderProfile}
            alt={msg.senderName}
            className="rounded-circle"
            style={{ width: 44, height: 44, objectFit: 'cover', border: '2px solid #BD3193' }}
          />
          <div style={{background: '#BD3193', color: 'white', borderRadius: 16, padding: '10px 16px', minWidth: 0, flex: 1, position: 'relative'}}>
            <div className="d-flex justify-content-between align-items-center mb-1">
              <span className="fw-bold" style={{fontWeight: 600}}>{msg.senderName}</span>
              <span className="ms-2" style={{fontSize: 12, opacity: 0.7}}>{msg.date}</span>
            </div>
            <div style={{fontSize: 15, wordBreak: 'break-word'}}>{msg.text || 'New message'}</div>
          </div>
        </li>
      ))}
    </ul>
  </div>
) : (
  <>
    <p className="small-txt txt-FFF opacity-_7 font-family-poppins font-weight-400 text-center">
      Select a user from the list to start a conversation
    </p>
    <p className="extra-small-txt txt-FFF opacity-_5 font-family-poppins mt-3">
      Messages are end-to-end encrypted and secure
    </p>
  </>
)}
        </div>
      )}
    </div>
  );
}
